import { render, staticRenderFns } from "./copyModal.vue?vue&type=template&id=1cb80d99&scoped=true"
import script from "./copyModal.vue?vue&type=script&lang=js"
export * from "./copyModal.vue?vue&type=script&lang=js"
import style0 from "./copyModal.vue?vue&type=style&index=0&id=1cb80d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb80d99",
  null
  
)

export default component.exports